import { render, staticRenderFns } from "./RezultatiSingle.vue?vue&type=template&id=1b211a8a&scoped=true&"
import script from "./RezultatiSingle.vue?vue&type=script&lang=js&"
export * from "./RezultatiSingle.vue?vue&type=script&lang=js&"
import style0 from "./RezultatiSingle.vue?vue&type=style&index=0&id=1b211a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b211a8a",
  null
  
)

export default component.exports